import EventEmitter from 'events';

export const READER_CONNECT_CHANGED = 'Reader/Connect/Changed';

export const PAD_CONNECT_CHANGED = 'Pad/Connect/Changed';

export const SDK_CONNECT_CHANGED = 'SDK/Connect/Changed';

export const SDK_CONNECT_ERROR = 'SDK/Connect/Error';

export const SDK_CONNECT_DONE = 'SDK/Connect/Done';

export const SDK_CONNECT_INTERRUPTED = 'SDK/Connect/Interrupted';

export const FINGERPRINT_DOWNLOADING_PROGRESS = 'Fingerprint/Downloading/Progress';

export const SDK_CODE_MISMATCH = 'SDK/Code/Mismatch';

export const KEY_MODE_UNSUPPORTED_UNLOCK = 'Key/Mode/UnsupportedUnlock';

export const DYNAMIC_LOCKNO_COLLECTED = 'Lock/No/Collected';

export const FINGERPRINT_GETTING_SIGNAL = 'Fingerprint/Getting/Signal';

export const KEY_INIT = 'Key/Init';

export const SDK_OCCUPIED_BY_OTHERS = 'SDK/Occupied/ByOthers';

export const AUTH_KEY_SUCCEED = 'Auth/Key/Succeed';

export default new EventEmitter();
